import React from 'react';
import { Box } from '@mui/material';
import { MailOutline } from '@mui/icons-material';

export const MessageNotification = ({ unreadCount }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <a href='/chat/inbox' style={{ display: 'flex', alignItems: 'center' }}>
            <MailOutline sx={{ fontSize: 32 }} style={{ color: 'white' }} />
        </a>
        {unreadCount > 0 && (
            <Box
                sx={{
                    minWidth: 20,
                    height: 20,
                    borderRadius: '50%',
                    backgroundColor: '#fff',
                    color: '#333',
                    fontSize: '12px',
                    fontWeight: 500,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    ml: '-6px'
                }}
            >
                {unreadCount}
            </Box>
        )}
    </Box>
);
